/** Keep public static content visible while the client loads its route. */
export const preservePrerenderedPage = (root: HTMLElement) => {
  if (root.dataset.prerendered !== 'true') {
    return;
  }

  const snapshot = root.cloneNode(true);

  if (!(snapshot instanceof HTMLElement)) {
    return;
  }

  snapshot.removeAttribute('id');
  snapshot.removeAttribute('data-prerendered');
  snapshot
    .querySelectorAll('[id]')
    .forEach((element) => element.removeAttribute('id'));
  root.before(snapshot);
  root.setAttribute('hidden', '');
  root.removeAttribute('data-prerendered');

  const observer = new MutationObserver(() => {
    if (
      root.querySelector(
        'main h1, main h2, main h3, main h4, main [role="alert"]',
      )
    ) {
      root.removeAttribute('hidden');
      snapshot.remove();
      observer.disconnect();
    }
  });

  observer.observe(root, { subtree: true, childList: true });
};
